import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Dropdown, Image, Modal, Row, Space, Table, Tag, Tooltip, Typography } from 'antd'
import { MoreOutlined, PlusOutlined, ReloadOutlined, FilterFilled, DownloadOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useNavigate } from 'react-router-dom'
import ExpandedData from './ExpandedData'
import axios from 'axios';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PDF from './PDF';
import AddFee from '../Fees/Add';
import FilteredModal from './FilteredModal';
import dayjs from 'dayjs';
import * as XLSX from "xlsx";


const { Title, Text } = Typography

const initialFilteredState = {
    perPage: 10,
    pageNo: 1,
    totalPage: 0,
    isModal: false,
    registrationNumber: "",
    fullName: "",
    phone: "92",
    email: "",
    batch: "",
    courseId: null,
    payment: null,
    session: null,
    result: null,
    learningType: null,
    gender: null,
    cnic: "",
    sortOrder: "latest",
}

const All = () => {

    const { user, getApiConfig } = useAuthContext()
    const [documents, setDocuments] = useState([])
    const [exportApplications, setExportApplications] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [filtered, setFiltered] = useState(initialFilteredState)
    const [shouldFetch, setShouldFetch] = useState(true)
    const [application, setApplication] = useState({})
    const [isAdmissionFormModalOpen, setIsAdmissionFormModalOpen] = useState(false)
    const [isFeeModalOpen, setIsFeeModalOpen] = useState(false)

    const navigate = useNavigate()

    const { pageNo, perPage, cnic, phone, fullName, registrationNumber, email, sortOrder, batch, payment, result, courseId, session, learningType, gender } = filtered
    const readDocuments = useCallback(async () => {
        setIsLoading(true)
        axios.get(`${window.api}/applications/all?pageNo=${pageNo}&perPage=${perPage}&searchCNIC=${cnic}&searchPhone=${phone}&searchName=${fullName}&searchRegNo=${registrationNumber}&searchEmail=${email}&sortOrder=${sortOrder}&searchCourseId=${courseId}&searchBatch=${batch}&searchSession=${session}&searchLearningType=${learningType}&searchResult=${result}&searchPayment=${payment}&searchGender=${gender}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    const array = data.applications.map(item => ({ ...item, key: item.id }))
                    setDocuments(array)
                    setFiltered(s => ({ ...s, pageNo: data.pagination.pageNo, perPage: data.pagination.perPage, totalPage: data.pagination.totalCount }))
                    if (array.length !== 0) {
                        const formattedArray = array.map(application => {
                            const filtered = Object.entries(application)
                                .filter(([key]) => !["uid", "id", "courseId", "_id", "__v", "isSendSMS", "updatedAt", "attachments", "photoURL", "key", "photoPublicId"].includes(key))
                                .map(([key, value]) => {
                                    const formatDateKeys = ["createdAt", "dob"];
                                    const locationKeys = ["city", "country", "province"];
                                    const formatted = formatDateKeys.includes(key)
                                        ? dayjs(value).format("DD-MM-YYYY") : locationKeys.includes(key)
                                            ? value?.name || "Unknown" : key === "course"
                                                ? value?.title || "Unknown" : value;
                                    return [key, formatted];
                                });
                            const session = application?.course?.session;
                            if (session) filtered.push(["session", session]);
                            return Object.fromEntries(filtered);
                        });
                        setExportApplications(formattedArray)
                    }
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the applications", "error")
            })
            .finally(() => {
                setIsLoading(false)
                setShouldFetch(false)
            })
    }, [getApiConfig, pageNo, perPage,  cnic, fullName, registrationNumber, email, sortOrder, phone, batch, payment, result, courseId, session, learningType, gender])

    useEffect(() => { if (shouldFetch) { readDocuments() } }, [shouldFetch, readDocuments])

    const sendSMS = async (formData) => {

        let { fullName, phone, registrationNumber } = formData
        let msg = `Dear ${fullName}, Thank you for choosing CoDev. You have all the rights to be happy for being a part of our campus. Your registration number is ${registrationNumber}.`

        const { REACT_APP_TELENOR_API_END_POINT, REACT_APP_TELENOR_LOGIN_ID, REACT_APP_TELENOR_LOGIN_PASSWORD } = process.env
        let sessionId;
        await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/auth.jsp?msisdn=${REACT_APP_TELENOR_LOGIN_ID}&password=${REACT_APP_TELENOR_LOGIN_PASSWORD}`)
            .then((res) => {
                console.log('res', res)
                sessionId = window.getDataFromHTML(res.data, "data");
            })
            .catch(err => {
                console.error(err)
                window.toastify("Something went wrong while getting session ID.", "error")
            })
        if (sessionId) {
            await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/sendsms.jsp?session_id=${sessionId}&to=${phone}&text=${msg}&mask=AlSeeraht`)
                .then((res) => {
                    let status = window.getDataFromHTML(res.data, "response");
                    if (status === "OK") {
                        window.toastify("SMS successfully sent", "success")
                    } else {
                        window.toastify("SMS not sent", "error")
                    }
                })
                .catch(err => {
                    console.error(err)
                    window.toastify("Something went wrong, We couldn't send SMS. Please contact support team.", "error")
                })
        }
    }
    const sendWhatsApp = async (formData) => {

        const { fullName, whatsapp,  registrationNumber } = formData
        const msg = `Dear ${fullName}, Thank you for choosing CoDev . You have all the rights to be happy for being a part of our campus. Your registration number is ${registrationNumber}.`

        const url = `https://wa.me/${whatsapp}?text=${msg}`
        window.open(url, "_blank")
    }

    const inviteViaEmail = (formData) => {

        const { fullName, email, uid, campus } = formData

        const url = `${window.origin}/auth/create-account/?email=${email}&id=${uid}`
        let data = { ...formData, url }

        const msg = {
            to: `salaam@umairahmad.net`,
            subject: `Invitation message from ${window.appName}`,
            text: `Salaam ${fullName}`,
            data
        };
        axios.post(`${window.api}/students/send-email-invitation`, msg, getApiConfig())
            .then(res => {
                const { status } = res
                if (status === 200) {
                    window.toastify("Email successfully sent", "success")
                }
            })
            .catch(err => {
                console.error(err)
                window.toastify("Something went wrong, We couldn't send email. Please contact support team.", "error")
            })
    }

    const getAdmissionForm = data => {
        setApplication(data)
        setIsAdmissionFormModalOpen(true)
    }

    const receiveFee = data => {
        setApplication(data)
        setIsFeeModalOpen(true)
    }

    // Filter Modal Close Function...
    const handleClose = () => {
        setFiltered(s => ({ ...s, isModal: false }))
    }

    // Filter Donations Function...
    const handleFilterApplications = () => {
        setFiltered(s => ({ ...s, isModal: false, pageNo: 1, perPage: 10 }))
        setShouldFetch(true)
    }

    // Refresh Function...
    const handleRefresh = () => {
        setFiltered(initialFilteredState)
        setShouldFetch(true)
    }

    const handleExportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(exportApplications);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate the Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "base64" });

        // Create a downloadable link
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelBuffer}`;
        link.download = "Codev Applications.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // const handleDeleteSelected = () => {
    //     console.log(selectedDocuments)
    // }

    // const hasSelected = selectedDocuments.length > 0;

    const columns = [
        {
            title: 'Image',
            render: (item, row) => <Image src={row.photoURL} alt={row.fullName} className="rounded-circle" style={{ width: 48, height: 48 }} />,
        },
        { title: 'Registration No.', dataIndex: 'registrationNumber', },
        { title: 'Full Name', dataIndex: 'fullName', },
        { title: 'CNIC', dataIndex: 'cnic', hidden: true },
        { title: 'Father CNIC', dataIndex: 'fatherCNIC', hidden: true },
        { title: 'Mother CNIC', dataIndex: 'motherCNIC', hidden: true },
        { title: 'Age', dataIndex: 'age', },
        { title: 'Email', dataIndex: 'email', hidden: true },
        { title: 'Phone', dataIndex: 'phone', render: (item, row) => <a href={`tel:+${item}`} target="_blank" rel="noopener noreferrer">{item}</a> },
        { title: 'WhatsApp', dataIndex: 'whatsapp', render: (item, row) => <a href={`https://wa.me/${item}`} target="_blank" rel="noopener noreferrer">{item}</a> },
        { title: 'Course', dataIndex: 'course.title', render: (item, row) => <Text>{row.course.title}</Text>, },
        { title: 'Batch', dataIndex: 'course.batch', render: (item, row) => <Text>{row.course.batch}</Text>, },
        { title: 'Learning', dataIndex: 'course.learningType', render: (item, row) => <Text className='text-capitalize'>{row.course.learningType}</Text>, },
        { title: 'Session', dataIndex: 'course.session', render: (item, row) => <Text>{row.course.session}</Text>, },
        { title: 'Status', dataIndex: 'status', render: (item, row) => <Tag color={window.getTagColor(item)} className='text-capitalize'>{item}</Tag>, },
        { title: 'Payment', dataIndex: 'payment', render: (item, row) => <Tag color={window.getTagColor(item)} className='text-capitalize'>{item}</Tag>, },
        { title: 'Result', dataIndex: 'result', render: (item, row) => <Tag color={window.getTagColor(item)} className='text-capitalize'>{item}</Tag>, },
        {
            title: 'Action',
            render: (_, row) => (
                <Dropdown
                    menu={{
                        items: [
                            { label: "Edit", onClick: () => { navigate(`/dashboard/applications/${row.cnic}`) } },
                            { label: "Send SMS", onClick: () => { sendSMS(row) } },
                            { label: "Send WhatsApp", onClick: () => { sendWhatsApp(row) } },
                            { label: "Invite", onClick: () => { inviteViaEmail(row) } },
                            { label: "Get Admission Form", onClick: () => { getAdmissionForm(row) } },
                            { label: "Receive Fee", onClick: () => { receiveFee(row) } },
                        ]
                    }}
                    trigger={['click']}
                >
                    <MoreOutlined className='text-primary' />
                </Dropdown>
            ),
        },
    ]

    const pdf = <PDF data={application} />

    return (
        <>
            <Row className='mb-3'>
                <Col>
                    <Title level={3} className="mb-0">Applications</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <Row className='mb-3'>
                            <Col span={24} className="d-flex justify-content-end align-items-center">
                                <Space size="small">
                                    {/* <Input placeholder="Search..." value={searchText} onChange={handleSearch} /> */}
                                    <Tooltip title="Filter Applications"><Button icon={<FilterFilled />} onClick={() => setFiltered(s => ({ ...s, isModal: true }))} /></Tooltip>
                                    <Tooltip title="Export Applications"><Button icon={<DownloadOutlined />} onClick={handleExportToExcel} /></Tooltip>
                                    <Tooltip title="Refresh Students"><Button icon={<ReloadOutlined />} onClick={handleRefresh} /></Tooltip>
                                    <Tooltip title="Add Student"><Button type='primary' icon={<PlusOutlined />} onClick={() => { navigate("/dashboard/applications/add") }} /></Tooltip>
                                </Space>
                            </Col>
                        </Row>

                        <Table
                            columns={columns.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
                            dataSource={documents}
                            loading={isLoading}
                            scroll={{ x: true }}
                            size="small"
                            // rowSelection={{
                            //     onChange: (keys, rows) => setSelectedDocuments(rows)
                            // }}
                            pagination={{
                                showSizeChanger: true,
                                total: filtered.totalPage,
                                pageSize: filtered.perPage,
                                showQuickJumper: true,
                                current: filtered.pageNo,
                                onChange: (pagination) => { setFiltered(s => ({ ...s, pageNo: pagination })); setShouldFetch(true) },
                                onShowSizeChange: (_, size) => { setFiltered((s) => ({ ...s, perPage: size })); setShouldFetch(true) },
                            }}
                            expandable={{
                                expandedRowRender: (row) => <ExpandedData data={row} />,
                                // rowExpandable: (row) => row.registrationNumber !== 1,
                            }}
                        />
                    </div>
                </Col>
            </Row>

            <FilteredModal open={filtered.isModal} filtered={filtered} setFiltered={setFiltered} handleFilterApplications={handleFilterApplications} handleClose={handleClose} />

            <Modal title="Admission Form" centered open={isAdmissionFormModalOpen} onCancel={() => setIsAdmissionFormModalOpen(false)} footer={null}>
                <PDFViewer width="100%" height="700">{pdf}</PDFViewer>

                <PDFDownloadLink document={pdf} fileName={`${window.appName} Admission Form - ${application.firstName}`}>
                    {({ blob, url, loading, error }) => <Button type='primary' block loading={loading}>Download Form</Button>}
                </PDFDownloadLink>
            </Modal>

            <Modal title="Receive Fee" centered className='p-2' width="100%" style={{ maxWidth: 1200 }} open={isFeeModalOpen} onCancel={() => setIsFeeModalOpen(false)} footer={null}>
                <AddFee application={application} setApplications={setDocuments} applications={documents} />
            </Modal>
        </>
    )
}

export default All